import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NO_ACCESS_URL, pageGroup } from '../core/permissions';
import { REPORT_CATALOG } from '../pages/admin/reports/report-catalog';

export const permissionGuard: CanActivateFn = (route) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.refreshPermissions().pipe(map(verified => {
    if (!verified) return router.parseUrl(NO_ACCESS_URL);
    let required = route.data?.['permission'] as string | string[] | undefined;
    const path = route.routeConfig?.path || '';
    if (path === 'legal') {
      const tab = route.queryParamMap.get('tab');
      if (tab) required = ['privacy', 'terms'].includes(tab) ? `legal.${tab}` : '__unknown_page__';
      else {
        const page = pageGroup('legal').find(page => auth.can(page.key));
        return router.parseUrl(page?.url || auth.firstAllowedUrl());
      }
    }
    if (path.startsWith('reports')) {
      const category = route.paramMap.get('category');
      if (category) required = `reports.${category}`;
      const reportId = route.queryParamMap.get('report');
      if (reportId) {
        const report = REPORT_CATALOG.find(report => report.id === reportId);
        if (!report || report.category !== category || !auth.can(report.permission)) return router.parseUrl(auth.firstAllowedUrl());
      }
    }
    const keys = required ? (Array.isArray(required) ? required : [required]) : [];
    return !keys.length || auth.canAny(keys) ? true : router.parseUrl(auth.firstAllowedUrl());
  }));
};
